import { Account, Auditable, Lockable, Person, QueryParams, Shipment, SortParams, Tissue } from "..";

export interface Order extends Auditable, Lockable {
    tenantId: number;
    name: string;
    shipBy?: string;
    hasUsageInfo: boolean;
    usageLocationId?: number;
    exportedTissue?: boolean;
    surgeonUserId?: number;
    billingAccountId?: number;

    usageLocation?: Account;
    surgeonUser?: Person;
    billingAccount?: Account;
    tissues?: Tissue[];
    shipment?: Shipment;
}

export const DefaultOrderQueryParams: QueryParams = {};

export const DefaultOrderSortParams: SortParams = {
    orderBy: "shipBy",
    orderDesc: "false",
};
